import React, { useRef, useState } from "react";
import CropperModal from "./CropperModal";
import { auctiondefaultLogo11 } from "../../constants/Images";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

const ImageCropper = (props) => {
  const [image, setImage] = useState(null);
  const { croppedImage, setCroppedImage, defaultimage, wid, inputId, hidePreview } = props;
  const fileInputId = inputId || "image";
  const [showCropperModal, setShowCropperModal] = useState(false);
  const inputFileRef = useRef(null);
  const handleFileChange = (e) => {
    const file = e.target.files ? e.target.files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.onload = () => {
          setImage(img);
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
      setShowCropperModal(true);
    }
  };

  const handleModalHide = () => {
    setShowCropperModal(false);
    setImage(null);
    if (inputFileRef.current) {
      inputFileRef.current.value = "";
    }
  };

  return (
    <>
      <CropperModal
        image={image}
        show={showCropperModal}
        onHide={handleModalHide}
        setCroppedImage={setCroppedImage}
      />
      <div className="" style={hidePreview ? { display: "none" } : undefined}>
        <label
          htmlFor={fileInputId}
          style={{
            cursor: "pointer",
            border: "1px solid gray",
            borderRadius: "5px",

          }}
        >
          {croppedImage ? (
            <img
              src={croppedImage}
              alt="Cropped"
              style={{
                height: wid ? wid : 100,
              }}
            />
          ) : (
            <img
              src={defaultimage}
              alt="Default"
              style={{
                height: wid ? wid : 100,
              }}
            />
          )}
        </label>
      </div>
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          id={fileInputId}

          style={{
            display: "none"
          }}
          ref={inputFileRef}
        />
    </>
  );
};

export default ImageCropper;
